"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BUAccountTokenManager = void 0;
const bu_account_api_flow_1 = require("./bu_account_api_flow");
const bu_account_types_1 = require("./bu_account_types");
class BUAccountTokenManager {
    constructor(host) {
        this.host = host;
        this.currentAccessToken = null;
        this.currentRefreshToken = null;
        this.isRefreshingAccessToken = false;
        this.lastRefreshAccessTokenTime = 0;
        this.shouldRefreshRefreshToken = true;
    }
    setAccessToken(token) {
        this.currentAccessToken = token;
        this.tokenStorage && this.tokenStorage.setToken(bu_account_types_1.BUAccountTokenUsage.access, token);
    }
    setRefreshToken(token) {
        var _a;
        this.currentRefreshToken = token;
        (_a = this.tokenStorage) === null || _a === void 0 ? void 0 : _a.setToken(bu_account_types_1.BUAccountTokenUsage.refresh, token);
    }
    getRefreshToken() {
        let refreshToken = this.currentRefreshToken;
        if (!refreshToken && this.tokenStorage) {
            refreshToken = this.tokenStorage.getToken(bu_account_types_1.BUAccountTokenUsage.refresh);
            if (refreshToken) {
                this.currentRefreshToken = refreshToken;
            }
        }
        if (!refreshToken) {
            return Promise.reject("not logged in");
        }
        const now = Date.now() / 1000;
        if (!this.shouldRefreshRefreshToken || refreshToken.expireAt - now > 7 * 24 * 60 * 60) {
            return Promise.resolve(refreshToken);
        }
        return (0, bu_account_api_flow_1.apiRequest)(this.host, "account/refresh_refresh_token", { refresh_token: refreshToken.token }, {}, null).then((result) => {
            const token = {
                use: bu_account_types_1.BUAccountTokenUsage.refresh,
                token: result.token || "",
                expireAt: result.expire_at || 0,
            };
            this.setRefreshToken(token);
            return token;
        });
    }
    getAccessToken(force = false) {
        var _a, _b, _c, _d;
        let accessToken = this.currentAccessToken;
        if (!accessToken && this.tokenStorage) {
            accessToken = this.tokenStorage.getToken(bu_account_types_1.BUAccountTokenUsage.access);
            if (accessToken) {
                this.currentAccessToken = accessToken;
            }
        }
        const now = Date.now();
        if ((!force || Math.abs(now - this.lastRefreshAccessTokenTime) < 30000) && accessToken) {
            const timeDiff = accessToken.expireAt - now / 1000;
            if (timeDiff > 5 * 60 ||
                (timeDiff > 0 &&
                    !this.shouldRefreshRefreshToken &&
                    this.currentRefreshToken &&
                    this.currentRefreshToken.expireAt <= accessToken.expireAt)) {
                return Promise.resolve(accessToken);
            }
        }
        if (this.isRefreshingAccessToken) {
            return new Promise((resolve, reject) => {
                const oldNotifier = this.accessTokenNotifier;
                const oldErrorNotifier = this.accessTokenErrorNotifier;
                this.accessTokenNotifier = (token) => {
                    if (oldNotifier) {
                        oldNotifier(token);
                    }
                    resolve(token);
                };
                this.accessTokenErrorNotifier = (error) => {
                    if (oldErrorNotifier) {
                        oldErrorNotifier(error);
                    }
                    reject(error);
                };
            });
        }
        if (((_b = (_a = this.tokenStorage) === null || _a === void 0 ? void 0 : _a.isAccessTokenRefreshLocked) === null || _b === void 0 ? void 0 : _b.call(_a)) && accessToken) {
            return Promise.resolve(accessToken);
        }
        (_d = (_c = this.tokenStorage) === null || _c === void 0 ? void 0 : _c.setAccessTokenRefreshLock) === null || _d === void 0 ? void 0 : _d.call(_c, true);
        this.isRefreshingAccessToken = true;
        return this.getRefreshToken()
            .then((refreshToken) => {
            return (0, bu_account_api_flow_1.apiRequest)(this.host, "account/refresh_access_token", { refresh_token: refreshToken.token }, {}, null).then((result) => {
                var _a, _b;
                this.lastRefreshAccessTokenTime = Date.now();
                this.isRefreshingAccessToken = false;
                (_b = (_a = this.tokenStorage) === null || _a === void 0 ? void 0 : _a.setAccessTokenRefreshLock) === null || _b === void 0 ? void 0 : _b.call(_a, false);
                const token = {
                    use: bu_account_types_1.BUAccountTokenUsage.access,
                    token: result.token || "",
                    expireAt: result.expire_at || 0,
                };
                this.setAccessToken(token);
                if (this.accessTokenNotifier) {
                    this.accessTokenNotifier(token);
                    this.accessTokenNotifier = undefined;
                }
                return token;
            });
        })
            .catch((error) => {
            var _a, _b;
            this.isRefreshingAccessToken = false;
            (_b = (_a = this.tokenStorage) === null || _a === void 0 ? void 0 : _a.setAccessTokenRefreshLock) === null || _b === void 0 ? void 0 : _b.call(_a, false);
            if (this.accessTokenErrorNotifier) {
                this.accessTokenErrorNotifier(error);
                this.accessTokenErrorNotifier = undefined;
            }
            throw error;
        });
    }
}
exports.BUAccountTokenManager = BUAccountTokenManager;
